import { Descriptions, Radio, Select } from 'antd';
import React, { useEffect } from 'react';
import SelectLevel from '../../../components/SelectLevel';
import { useGetBookInformationByBookNoQuery } from '../../../api/books/bookManagement.api';
import { useTranslation } from 'react-i18next';
import Spinner from '../../../components/Spinner';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';
import { campusHeadOffice } from '../../../lib/data';

const BookBasicInformation = ({
  selectedRow,
  isModify,
  information,
  setInformation,
}: any) => {
  const { t } = useTranslation();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  const { currentCampus: campusCode } = useSelector(
    (state: RootState) => state.auth,
  );
  const { data, isLoading } = useGetBookInformationByBookNoQuery(
    {
      bookNo: selectedRow?.bookNo ?? 0,
      campusCode,
    },
    { skip: !campusCode || !selectedRow?.bookNo },
  );
  const genres = commonCodes.find(
    (item) => item.commonCode === 'BK0001',
  )?.detailCode;
  const isHeadOffice = (campusCode: string) => campusCode === campusHeadOffice;

  useEffect(() => {
    if (!data?.data.bookDto) {
      setInformation(null);
      return;
    }

    setInformation(data.data.bookDto);
  }, [data]);

  useEffect(() => {
    if (selectedRow?.bookNo) return;

    setInformation(null);
  }, [selectedRow]);

  const handleChangeValue = (e: any) => {
    setInformation({ ...information, [e.target.name]: e.target.value });
  };

  return (
    <>
      <div className='comm-table__area rowType'>
        {isLoading ? (
          <Spinner />
        ) : (
          <Descriptions bordered size="small" column={1}>
            <Descriptions.Item
              label={`${t('booksManagement.books.column2')} *`}
            >
              <input
                type="text"
                className="form-control input-text"
                value={information?.bookName ?? ''}
                name={'bookName'}
                onChange={handleChangeValue}
                disabled={!isModify}
              />
            </Descriptions.Item>
            <Descriptions.Item
              label={`${t('booksManagement.books.column3')} *`}
            >
              <input
                type="text"
                className="form-control input-text"
                value={information?.author ?? ''}
                name={'author'}
                onChange={handleChangeValue}
                disabled={!isModify}
              />
            </Descriptions.Item>
            <Descriptions.Item
              label={`${t('booksManagement.books.column4')} *`}
            >
              <input
                type="text"
                className="form-control input-text"
                value={information?.isbn ?? ''}
                name={'isbn'}
                maxLength={13}
                onChange={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9.]/g, '')
                    .replace(/(\..*)\./g, '$1');
                  handleChangeValue(e);
                }}
                disabled={!isModify}
              />
            </Descriptions.Item>
            <Descriptions.Item
              label={`${t('booksManagement.books.column5')} *`}
            >
              <input
                type="text"
                className="form-control input-text"
                value={information?.publisherName ?? ''}
                name={'publisherName'}
                onChange={handleChangeValue}
                disabled={!isModify}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t('booksManagement.books.column6')}>
              <input
                type="text"
                className="form-control input-text"
                onChange={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9.]/g, '')
                    .replace(/(\..*)\./g, '$1');
                  handleChangeValue(e);
                }}
                name={'publicationYear'}
                value={information?.publicationYear ?? ''}
                maxLength={4}
                disabled={!isModify}
              />
            </Descriptions.Item>
            {!isHeadOffice(campusCode) && !isModify && (
              <Descriptions.Item label={t('booksManagement.books.column43')}>
                {information?.copyCount}
              </Descriptions.Item>
            )}
            <Descriptions.Item label={t('booksManagement.books.column7')}>
              <input
                type="text"
                className="form-control input-text"
                value={information?.seriesName ?? ''}
                name={'seriesName'}
                onChange={handleChangeValue}
                disabled={!isModify}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t('booksManagement.books.column8')}>
              <Select
                className="w-100"
                placeholder={t('booksManagement.books.column8')}
                onChange={(value) =>
                  setInformation({ ...information, genreDiv: value })
                }
                value={information?.genreDiv && information?.genreDiv}
                disabled={!isModify}
              >
                {genres?.map((item) => (
                  <Select.Option
                    key={item.detailCode}
                    value={item.detailCode}
                  >
                    {item.korName}
                  </Select.Option>
                ))}
              </Select>
            </Descriptions.Item>
            <Descriptions.Item
              label={`${t('booksManagement.books.column9')} *`}
            >
              <div className='auth-radio__area'>
                <Radio.Group
                  name="bookDiv"
                  value={information?.bookDiv}
                  onChange={handleChangeValue}
                  disabled={!isModify}
                >
                  <Radio value={'FC'}>
                    {t('booksManagement.books.column44')}
                  </Radio>
                  <Radio className="ml-3" value={'NF'}>
                    {t('booksManagement.books.column45')}
                  </Radio>
                </Radio.Group>
              </div>
            </Descriptions.Item>
            <Descriptions.Item label={t('booksManagement.books.column10')}>
              <input
                type="text"
                className="form-control input-text"
                value={information?.theme ?? ''}
                name={'theme'}
                onChange={handleChangeValue}
                disabled={!isModify}
              />
            </Descriptions.Item>
            <Descriptions.Item
              label={`${t('booksManagement.books.column11')} *`}
            >
              <SelectLevel
                value={
                  information?.courseCode && String(information?.courseCode)
                }
                placeHolder={'CANB Level'}
                onChange={(value) =>
                  setInformation({ ...information, courseCode: value })
                }
                disabled={!isModify}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t('booksManagement.books.column12')}>
              <input
                type="text"
                className="form-control input-text"
                value={information?.bookLevel ?? ''}
                name={'bookLevel'}
                onChange={handleChangeValue}
                disabled={!isModify}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t('booksManagement.books.column47')}>
              <textarea
                className="w-100"
                rows={3}
                name={'specialDesc'}
                onChange={handleChangeValue}
                value={information?.specialDesc ?? ''}
                disabled={!isModify}
              />
            </Descriptions.Item>
          </Descriptions>
        )}
      </div>
    </>
  );
};

export default BookBasicInformation;
